import { UrlConstants } from "../url.constants";
export class ApiReportConstants {
    static URL = UrlConstants.API_V2 + "Report";
    static FUNCTION_GENERATE_REPORT = "GenerateReport";
    static FUNCTION_UPLOAD_REPORT_SOURCE = "UploadReportSource";
    static FUNCTION_DELETE_MULTIPLE_REPORTS = "DeleteMultipleReports";
    static FUNCTION_GET_REPORT_SOURCE = "GetReportSource";
}
